import React, { createContext, useContext, useState, useEffect } from "react";

// 1. Create the Context
export const ThemeContext = createContext();

// 2. Create the Provider Component
export const ThemeProvider = ({ children }) => {
  const [activeTheme, setActiveTheme] = useState(() => {
    // Priority 1: Check Local Storage
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) return savedTheme;

    // Priority 2: Check System Preference (Dark Mode vs Light Mode)
    const systemPrefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    return systemPrefersDark ? "dark" : "light";
  });

  // 3. Update the DOM and LocalStorage whenever the theme changes
  useEffect(() => {
    const body = document.body;
    
    // Remove both classes to ensure a clean swap
    body.classList.remove("light-mode", "dark-mode");
    body.classList.add(`${activeTheme}-mode`);
    
    // Save selection for future visits
    localStorage.setItem("theme", activeTheme);
  }, [activeTheme]);

  // 4. Helper function to switch themes
  const handleThemeChange = (theme) => {
    setActiveTheme(theme);
  };

  const toggleTheme = () => {
    setActiveTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <ThemeContext.Provider value={{ activeTheme, handleThemeChange, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

// 5. Custom Hook for easy access (Optional but recommended)
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};